import { gql } from "@apollo/client";
const FEDERATION_BY_ID = gql`
  query federationDetails($id: Int! $platform:Int) {
    federationDetails(id: $id platform:$platform)
  }
`;
export default FEDERATION_BY_ID;
